import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Atividade } from '../../../../model/processo/Atividade';
import { validarDescricao, validarUnidade, validarLugar } from '../utils/validadores';
import { CronogramaViewModel } from '../../../../viewmodel/CronogramaViewModel';
import { BancaTagUtils } from '../../../../utils/BancaTagUtils';

interface ModalCriarAtividadeProps {
  show: boolean;
  onHide: () => void;
  onSave: (atividade: Atividade) => void;
  selectedDate: Date;
  cronogramaId: string;
}

const ModalCriarAtividade: React.FC<ModalCriarAtividadeProps> = ({ show, onHide, onSave, selectedDate, cronogramaId }) => {
  const [descricao, setDescricao] = useState('');
  const [unidade, setUnidade] = useState('');
  const [lugar, setLugar] = useState('');
  const [hora, setHora] = useState('');
  const [isDataBanca, setIsDataBanca] = useState(false);

  const handleSave = async () => {
    if (!validarDescricao(descricao)) {
      alert('Descrição deve ter no máximo 100 caracteres.');
      return;
    }

    if (!validarUnidade(unidade)) {
      alert('Unidade deve ter no máximo 100 caracteres.');
      return;
    }

    if (!validarLugar(lugar)) {
      alert('Lugar deve ter no máximo 100 caracteres.');
      return;
    }

    const descricaoFinal = isDataBanca ? BancaTagUtils.addBancaTag(descricao) : descricao;

    const novaAtividade: Atividade = {
      id: '',
      descricao: descricaoFinal,
      unidade,
      lugar,
      data: selectedDate.toISOString().split('T')[0],
      hora,
      cronogramaId: cronogramaId,
    };

    try {
      const atividadeCriada = await CronogramaViewModel.criarAtividadeUsuario(novaAtividade);
      onSave(atividadeCriada);
      setDescricao('');
      setHora('');
      setLugar('');
      setUnidade('');
      setIsDataBanca(false);
      onHide();
    } catch (error) {
      console.error('Erro ao criar atividade:', error);
      alert('Erro ao criar atividade. Tente novamente.');
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Criar Atividade</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Descrição</Form.Label>
            <Form.Control type="text" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Unidade</Form.Label>
            <Form.Control type="text" value={unidade} onChange={(e) => setUnidade(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Local</Form.Label>
            <Form.Control type="text" value={lugar} onChange={(e) => setLugar(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Hora</Form.Label>
            <Form.Control type="time" value={hora} onChange={(e) => setHora(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check 
              type="checkbox"
              id="isDataBanca"
              label="📅 Esta atividade refere-se a uma Data de Banca"
              checked={isDataBanca}
              onChange={(e) => setIsDataBanca(e.target.checked)}
            />
            {isDataBanca && (
              <Form.Text className="text-muted">
                ℹ️ Esta atividade será marcada como banca no cronograma geral
              </Form.Text>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="primary" onClick={handleSave}>Salvar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCriarAtividade;
